import { TextField, MenuItem, Select, Slider, Autocomplete } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { FormattedMessage } from "react-intl";

const DEBUG = false;

export default function FilterInput({
    type,
    value,
    onChange,
    items,
    scale }) {
    if (DEBUG) console.log("FilterInput :: Render");
    if (DEBUG) console.log(type, value, items, scale);

    switch (type) {
        case "date":
            return <DatePicker
                value={value || null}
                onChange={(newValue) => {
                    if (!newValue || isNaN(new Date(newValue).getTime())) return;
                    onChange(newValue || null);
                }
                } // Ensure it's not undefined
                sx={{ textAlign: "right" }}
                renderInput={
                    (params) => <TextField
                        variant="standard"
                        size="small"
                        InputProps={{ sx: { textAlign: "right" } }}
                        {...params} />}
            />;
        case "free-text":
            return <TextField
                variant="standard"
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                size="small" />;
        case "dropdown":
        case "select":
            if (items && items.length > 12) {
                return (
                    <Autocomplete
                        multiple={false}
                        options={items}
                        value={value || ""}
                        onChange={(_, newValue) => onChange(newValue)}
                        size="small"
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                label={
                                    null
                                    //<FormattedMessage id="filter.select" />
                                }
                                sx={{ minWidth: 160 }}
                            />
                        )}
                        disableCloseOnSelect
                        isOptionEqualToValue={(option, value) => option === value}
                    />)
                    ;
            } else {
                return (
                    <Select
                        value={value || ""}
                        onChange={(e) => onChange(e.target.value)}
                        variant="standard"
                        disableUnderline="true"
                        multiple={false}
                        size="small">
                        <MenuItem value={""}>
                            <em>
                                <FormattedMessage
                                    id="filter.select" />
                            </em>
                        </MenuItem>
                        {items?.map((item) => (
                            <MenuItem key={item} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                );
            }
        case "multiselect":
            if (items && items.length > 12) {
                return (
                    <Autocomplete
                        multiple
                        options={items}
                        value={value || []}
                        onChange={(_, newValue) => onChange(newValue)}
                        size="small"
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                label={
                                    null
                                    //<FormattedMessage id="filter.select" />
                                }
                                sx={{ minWidth: 150 }}
                            />
                        )}
                        disableCloseOnSelect
                        isOptionEqualToValue={(option, value) => option === value}
                    />)
                    ;
            } else {
                return (
                    <Select
                        value={value || []}
                        onChange={(e) => onChange(e.target.value)}
                        variant="standard"
                        disableUnderline="true"
                        multiple={true}
                        size="small">
                        <MenuItem value={[]}>
                            <em>
                                <FormattedMessage
                                    id="filter.select" />
                            </em>
                        </MenuItem>
                        {items?.map((item) => (
                            <MenuItem key={item} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                );
            }

        case "int":
            return (
                <TextField
                    value={value || "none"}
                    variant="standard"
                    size="small"
                    type="number"
                    onChange={(e) => onChange(e.target.value)}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            );
        case "int":
            return (
                <Slider
                    value={value || (scale ? [scale[0], scale[1]] : [0, 100])} // Default to full range
                    onChange={(_, newValue) => onChange(newValue)} // newValue is now an array
                    min={scale ? scale[0] : 0}
                    max={scale ? scale[1] : 100}
                    valueLabelDisplay="auto"
                    sx={{ width: 150 }} // Ensures it's visible
                />
            );
        default:
            return null;
    }
}